import {
    GET_RAPPORT_CONFIRMED_ACTION,
    GET_RAPPORT_FAILED_ACTION,
    LOADING_TOGGLE_ACTION,
    GET_PATOLOGIE_AMBU_CONFIRMED_ACTION,
    GET_PATOLOGIE_HOSPI_CONFIRMED_ACTION,
    GET_PRESTATION_AMBU_CONFIRMED_ACTION,
    GET_PRESTATION_HOSPI_CONFIRMED_ACTION,
    GET_TOP_DENTISTE_CONFIRMED_ACTION,
    GET_TOP_PHARMACIE_CONFIRMED_ACTION,
    GET_TOP_OPTIQUE_CONFIRMED_ACTION,
    GET_RAPPORT_FINANCE_CONFIRMED_ACTION,
    GET_RAPPORT_DEPENSE_FAMILLE_CONFIRMED_ACTION,
    GET_GLOBAL_CLIENT_STATS_CONFIRMED_ACTION,
    GET_DETAILDED_CLIENT_STATS_CONFIRMED_ACTION,
    GET_VISITS_CLIENT_STATS_CONFIRMED_ACTION,
    GET_CONSOMMATIONS_CLIENT_STATS_CONFIRMED_ACTION,
    GET_TOP_CONSOMMATIONS_CLIENT_STATS_CONFIRMED_ACTION,
    FETCH_PRESTAIRES_STATS_REQUEST,
    FETCH_PRESTAIRES_STATS_SUCCESS,
    FETCH_PRESTAIRES_STATS_FAILURE,
    FETCH_PERIOD_STATS_REQUEST,
    FETCH_PERIOD_STATS_SUCCESS,
    FETCH_PERIOD_STATS_FAILURE,
    FETCH_PROVIDERS_STATUS_REQUEST,
    FETCH_PROVIDERS_STATUS_SUCCESS,
    FETCH_PROVIDERS_STATUS_FAILURE
} from '../actions/RapportAction';

const initialState = {
    dataDepenseFami: {},
    dataAmbuSous: [],
    prestAmbu: [],
    prestHospi: [],
    patoAmbu: [],
    patoHospi: [],
    topPharmacies: [],
    topDentistes: [],
    topOptiques: [],
    rapportFinance: [],
    globalClientStats: {},
    detailedClientStats: {},
    visitsClientsStats: [],
    consommationsClientStats: [],
    topConsommationsClientStats: [],
    prestataires: {
        loading: false,
        data: [],
        error: null
      },
    periodStats: {
        loading: false,
        data: [],
        periodType: 'mensuel',
        error: null
    },
    stats: {
        totalProviders: 0,
        onlineProviders: 0,
        offlineProviders: 0,
        recentlyActive: 0
    },
    providers: [],
    lastUpdated: null,
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export const RapportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RAPPORT_CONFIRMED_ACTION:
            return {
                ...state,
                dataAmbuSous: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };
        case GET_RAPPORT_FINANCE_CONFIRMED_ACTION:
            return {
                ...state,
                rapportFinance: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };
        case GET_PRESTATION_AMBU_CONFIRMED_ACTION:
            return {
                ...state,
                prestAmbu: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
        }; 
        case GET_PRESTATION_HOSPI_CONFIRMED_ACTION:
            return {
                ...state,
                prestHospi: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
        }; 
        case GET_PATOLOGIE_AMBU_CONFIRMED_ACTION:
            return {
                ...state,
                patoAmbu: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };
        case GET_PATOLOGIE_HOSPI_CONFIRMED_ACTION:
            return {
                ...state,
                patoHospi: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };  
        case GET_TOP_DENTISTE_CONFIRMED_ACTION:
            return {
                ...state,
                topDentistes: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };   
        case GET_TOP_OPTIQUE_CONFIRMED_ACTION:
            return {
                ...state,
                topOptiques: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };
        case GET_RAPPORT_DEPENSE_FAMILLE_CONFIRMED_ACTION:
            return {
                ...state,
                dataDepenseFami: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            }; 
        case GET_TOP_PHARMACIE_CONFIRMED_ACTION:
            return {
                ...state,
                topPharmacies: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            }; 
        case GET_GLOBAL_CLIENT_STATS_CONFIRMED_ACTION:
            return {
                ...state,
                globalClientStats: action.payload,
                errorMessage: '',
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            }; 
        case GET_DETAILDED_CLIENT_STATS_CONFIRMED_ACTION:
            return {
                ...state,
                detailedClientStats: action.payload,
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            }; 
        case GET_VISITS_CLIENT_STATS_CONFIRMED_ACTION:
            return {
                ...state,
                visitsClientsStats: action.payload,
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            }; 
        case GET_CONSOMMATIONS_CLIENT_STATS_CONFIRMED_ACTION:
            return {
                ...state,
                consommationsClientStats: action.payload,
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            }; 
        case GET_TOP_CONSOMMATIONS_CLIENT_STATS_CONFIRMED_ACTION:
            return {
                ...state,
                topConsommationsClientStats: action.payload,
                successMessage: 'Notifications listing Successfully Completed',
                showLoading: false,
            };      
        case FETCH_PROVIDERS_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
            
            case FETCH_PROVIDERS_STATUS_SUCCESS:
            // Calculer les statistiques à partir des données reçues
            const providers = action.payload;
            const totalProviders = providers.length;
            const onlineProviders = providers.filter(p => p.isOnline).length;
            const offlineProviders = totalProviders - onlineProviders;
            const recentlyActive = providers.filter(p => 
                !p.isOnline && 
                new Date(p.lastActivityTime) > new Date(Date.now() - 24 * 60 * 60 * 1000)
            ).length;
            
            return {
                ...state,
                providers: providers,
                loading: false,
                error: null,
                stats: {
                totalProviders,
                onlineProviders,
                offlineProviders,
                recentlyActive
                },
                lastUpdated: new Date()
            };
            
            case FETCH_PROVIDERS_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case GET_RAPPORT_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };
        case FETCH_PRESTAIRES_STATS_REQUEST:
            return {
                ...state,
                prestataires: {
                    ...state.prestataires,
                    loading: true,
                    error: null
                  },
                successMessage: '',
                showLoading: false,
            };
        case FETCH_PRESTAIRES_STATS_SUCCESS:
            return {
                ...state,
                prestataires: {
                loading: false,
                data: action.payload,
                error: null
                },
                successMessage: '',
                showLoading: false,
            };
        case FETCH_PRESTAIRES_STATS_FAILURE:
            return {
                ...state,
                prestataires: {
                ...state.prestataires,
                loading: false,
                error: action.payload
                },
                successMessage: '',
                showLoading: false,
            };
            
            // Period stats
        case FETCH_PERIOD_STATS_REQUEST:
            return {
                ...state,
                periodStats: {
                ...state.periodStats,
                loading: true,
                error: null
                },
                successMessage: '',
                showLoading: false,
            };
            
            case FETCH_PERIOD_STATS_SUCCESS:
            return {
                ...state,
                periodStats: {
                loading: false,
                data: action.payload.data,
                periodType: action.payload.periodType,
                error: null
                },
                successMessage: '',
                showLoading: false,
            };
            
            case FETCH_PERIOD_STATS_FAILURE:
            return {
                ...state,
                periodStats: {
                ...state.periodStats,
                loading: false,
                error: action.payload
                },
                successMessage: '',
                showLoading: false,
            };            
        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                showLoading: true,
            };
        default:
          return state;
    };
};